<template>
  <div class="width-a">
    <div class="navigate"><span>首页 > </span><span>新闻中心 > </span><span>{{newsDetial.newsTitle}} > </span></div>
    <h1 class="title">{{newsDetial.newsTitle}}</h1>
    <div class="frcs">
      <div>
        <span class="auter">撰写人：{{newsDetial.writer}}</span>
        <span class="auter">审核人：{{newsDetial.auditor}}</span>
        <span class="auter">发布人：{{newsDetial.publisher}}</span>
      </div>
      <div class="time">{{newsDetial.publishTime}}</div>
    </div>
    
    <div class="img-a">
      <img :src="newsDetial.imageUrl | fileFilter" alt="">
    </div>
    <div class="ql-editor" v-html="newsDetial.newsContent"></div>
  </div>
</template>

<script>
  import "quill/dist/quill.core.css";
  import "quill/dist/quill.snow.css";
  import "quill/dist/quill.bubble.css";
  import Quill from "quill";
  import CommonFilters from "@/mixins/CommonFilters";
  import HttpConnectionC from "@/utils/HttpConnectionC";
  export default {
    name: "NewsDetail",
    mixins: [CommonFilters],
    data () {
      return {
        newsDetial: {},
        newsContent: ''
      }
    },
    mounted () {
      let that = this;
      let _id = that.$route.query.newsId;
      HttpConnectionC.get(`/homepage/readNews/${_id}`).then(function (response) {
        that.newsDetial = response.data;
        console.log(that.newsDetial.newsContent);
      });
    }
  };
</script>

<style scoped lang="scss">
  .navigate {
    font-size: 14px;
    font-weight: 400;
    color: #4d4d4d;
  }

  .title {
    font-size: 32px;
    font-weight: 400;
    color: #000000;
    margin: 8px 0px 20px 0px;
  }

  .time {
    font-size: 16px;
    font-weight: 400;
    color: #b3b3b3;
    margin: 0px 0px 20px 0px;
  }

  .img-a {
    width: 1180px;
    height: 540px;
    margin-bottom: 50px;

    img {
      width: auto;
      height: 540px;
      margin: auto;
    }
  }

  // /deep/.content {
  //   margin: 28px 0px 28px 0px;
  //   line-height: 1.5;
  //   p {
  //     text-indent: 24px;
  //   }
  // }
  // /deep/.ql-align-center {
  //   text-align: center;
  //   img {
  //     display: inline-block;
  //   }
  // }
  /deep/ .ql-align-center {
    img {
      display: inline-block;
    }
  }
  .auter{
    font-size: 14px;
    color: #4d4d4d;
    margin-right: 20px;
  }
</style>